import $ from 'jquery';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import _Template from 'properties/main/radio-button.ejs';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class MainRadioButtonValueView extends BasePropertyView {


    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes',
            'change input[type=text]' : 'updateTextAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if (this.model.get('selected') === undefined) {
            this.model.set('selected', false, {silent: true});
        }

        if (this.model.get('value') === undefined) {
            this.model.set('value', '', {silent: true});
        }
        

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( 'selected', propVal );

        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: 'selected', val: propVal});

        //console.log(`MainHeaderView model.set(${propName}, ${this.model.get( propName )})`);
    }

    updateTextAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );

        //console.log(`MainHeaderView model.set(${propName}, ${this.model.get( propName )})`);

    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        let bSelected = util.isTrue(this.model.get('selected'));
        $(`input[name='isSelected']`).prop('checked', bSelected );

        this.delegateEvents();
        return this;
    }

}

export default MainRadioButtonValueView;